import getTopics from 'services/apiHelpers/getTopics';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import { Block } from '@chameleoncreator/creator-app';

export default () =>
  getTopics().reduce((acc: Block[], curr: Block) => {
    return [...acc, ...getInteractionsInTopic(curr).map(i => i?.id)] as Block[];
  }, []);
